
import React from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import DateIcon from "../../../../Shared/components/Icons/Date";
import { Button, Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Row, Col, Space } from "antd";
import clsx from "clsx";
import { idNamingConversion } from '../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";

export const CustomForm = (props) => {
    const { visible, handleClose, createBatch, changeHandler, form, error, customObject, customerGroupdetails, customerDetails } = props;

    const classes = customStyles();
    return <PrimaryDrawer
        anchor={'right'}
        open={visible}
        variant={'temporary'}
        handleClose={() => handleClose()}
        title={`Run Price Query`}
        width={'495px'}
        className={clsx(classes.closeBackGround, classes.width100P)}
        component={
            <Box
                className={clsx(classes.customForm, classes.removeUnderline)}
                component="form"
                autoComplete="off"
                onSubmit={(e) => createBatch(e)}>
                <div className={classes.customFormFlex}>
                    <Row type="flex" gutter={40}>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.typographyHeader, classes.bold)}>Product Filter</Typography>
                            <FormControl
                                className={clsx(classes.margin10t, classes.dropDownPointer, classes.customRadioButton)}
                                variant={'standard'}
                                fullWidth>
                                <RadioGroup
                                    row
                                    defaultValue={1}
                                    aria-labelledby="demo-customized-radios"
                                    name="productFilter"
                                    value={form.productFilter}
                                    id={idNamingConversion('Product Filter', 'outBoundPrice', 'Radio')}
                                    onChange={(e) => changeHandler(e)}>
                                    <FormControlLabel value={'catalogue'} control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Catalogue" />
                                    <FormControlLabel value={'nonCatalogue'} control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Non Catalogue" />
                                </RadioGroup>
                            </FormControl>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin30t, classes.typographyHeader, classes.bold)}>Filter By</Typography>
                            <FormControl
                                className={clsx(classes.margin10t, classes.dropDownPointer, classes.customRadioButton)}
                                variant={'standard'}
                                fullWidth>
                                <RadioGroup
                                    row
                                    defaultValue={1}
                                    aria-labelledby="demo-customized-radios"
                                    name="filterBy"
                                    value={form.filterBy}
                                    id={idNamingConversion('Filter By', 'outBoundPrice', 'Radio')}
                                    onChange={(e) => changeHandler(e)}>
                                    <FormControlLabel value={'ALL'} control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="All Customers" />
                                    <FormControlLabel value={'GROUP'} control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Customer Group" />
                                    <FormControlLabel value={'SPECIFIC'} control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Customer" />
                                </RadioGroup>
                            </FormControl>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.customerLabelNone}>
                            {
                                form?.filterBy === 'GROUP' && <AutoCompleteComponent
                                    customLabel={'Customer Group'}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={customerGroupdetails}
                                    parentValue={customObject(customerGroupdetails, form?.groupId)}
                                    position={"bottom"}
                                    variant={'outlined'}
                                    id={idNamingConversion('Customer Group', 'outBoundPrice', 'DropDown')}
                                    customClasses={classes.margin30t}
                                    onChange={(data) => changeHandler(data.id, 'groupId')}
                                    parentError={error.groupId}
                                />
                            }
                            {
                                form?.filterBy === 'SPECIFIC' && <AutoCompleteComponent
                                    customLabel={'Customer'}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={customerDetails}
                                    id={idNamingConversion('Customer', 'outBoundPrice', 'DropDown')}
                                    parentValue={customObject(customerDetails, form?.customerId)}
                                    position={"bottom"}
                                    variant={'outlined'}
                                    customClasses={classes.margin30t}
                                    onChange={(data) => changeHandler(data.id, 'customerId')}
                                    parentError={error.customerId}
                                />
                            }
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={form?.fromDate}
                                        format='dd/MM/yyyy'
                                        label="From Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('From Date', 'outBoundPrice', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                changeHandler(new Date(), 'fromDate') :
                                                changeHandler(newValue, 'fromDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={form?.toDate}
                                        minDate={new Date(form?.fromDate)}
                                        label="To Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('To Date', 'outBoundPrice', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        format="dd/MM/yyyy"
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                changeHandler(new Date(), 'toDate')
                                                : changeHandler(newValue, 'toDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className={clsx(classes.btnParent)}>
                    <Space size={[10, 10]} direction="horizontal" align="center">
                        <Button
                            key="ok"
                            color="primary"
                            variant="contained"
                            type={'submit'}
                            className={clsx(classes.modalBtn)}>
                            OK
                        </Button>
                        <Button
                            key="cancel"
                            color="primary"
                            variant="contained"
                            onClick={() => handleClose()}
                            className={clsx(classes.AddMoreBtn)}
                        >Cancel</Button>
                    </Space>
                </div>
            </Box>
        }
    />
}